export default __webpack_public_path__ + "static/media/smile-icon.b614a129.svg";